import { ProductUrlType } from '@noths/polaris-dev-ts-types';
import { createAction } from '@reduxjs/toolkit';

interface ProductClickPayload {
  destinationUrl: ProductUrlType;
  productUrl: ProductUrlType;
  productCode: number;
  shouldUseEventCallback: boolean;
}

export const onProductClick = createAction<ProductClickPayload>('products/clickProductImpression');
